import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHorizontalAlignmentBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHorizontalAlignmentBottom"><Path d="M6 3V17H11V3H6Z" fill="currentColor"/><Path d="M13 7V17H18V7H13Z" fill="currentColor"/><Path d="M3 19V21H21V19H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHorizontalAlignmentBottom;
